var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldHeadphones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12V6c0-.41.34-.75.75-.75s.75.34.75.75v6c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM7.75 22v-4c0-.41.34-.75.75-.75s.75.34.75.75v4c0 .41-.34.75-.75.75s-.75-.34-.75-.75zM14.75 22V6c0-.41.34-.75.75-.75s.75.34.75.75v16c0 .41-.34.75-.75.75s-.75-.34-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57 6.57c-.33.33-.78.53-1.27.53H6.05c.28-.37.45-.85.45-1.35v-.9c0-.5-.17-.98-.45-1.35H8.3c.99 0 1.8.81 1.8 1.8 0 .49-.2.94-.53 1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.748c0 .5-.17.98-.45 1.35-.76 1.01-2.32 1.35-3.77.06-.16-.14-.28-.44-.28-.65v-2.34c0-.2.1-.47.23-.61 1.26-1.32 2.78-1.13 3.61-.3a2.257 2.257 0 0 1 .66 1.59v.9zM14.43 6.57c.33.33.78.53 1.27.53h2.25c-.28-.37-.45-.85-.45-1.35v-.9c0-.5.17-.98.45-1.35H15.7c-.99 0-1.8.81-1.8 1.8 0 .49.2.94.53 1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.748c0 .5.17.98.45 1.35.76 1.01 2.32 1.35 3.77.06.16-.14.28-.44.28-.65v-2.34c0-.19-.1-.47-.23-.61-1.26-1.32-2.78-1.13-3.61-.3a2.257 2.257 0 0 0-.66 1.59v.9zM10 17.5c0 .83-.67 1.5-1.5 1.5S7 18.33 7 17.5v-4c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldHeadphones);
export default __webpack_public_path__ + "static/media/vuesax-bold-headphones.d951f558f9dcb1e64401d9887c6574b6.svg";
export { ForwardRef as ReactComponent };